<template>
<div class="animated fadeIn mt-5" v-if="dataLoaded">
  <form enctype="multipart/form-data" v-on:submit="validateBeforeSubmit($event,false)">
    <div class="row">
      <b-col md="6">
        <b-card>
          <div slot="header">
            <strong>Item</strong>
          </div>

          <b-form-row>
            <b-col md="6">
              <b-form-group label="Ano / Mês">
                <b-form-input type="number" step="1" min="0" name="ym" v-model="item.ym" placeholder="Ano / Mês"  v-validate="'required'" :state="validateState('ym')"></b-form-input>
                <b-form-invalid-feedback>
                  {{ errors.first('ym') }}
                </b-form-invalid-feedback>
              </b-form-group>

            </b-col>

            <b-col md="4">
              <b-form-group label="ST">
                <b-form-input type="text" name="stars_st_code" v-model="item.stars_st_code" placeholder="ST"  v-validate="'required'" :state="validateState('stars_st_code')"></b-form-input>
                <b-form-invalid-feedback>
                  {{ errors.first('stars_st_code') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group label="CHA">
                <b-form-input type="text" name="stars_cha_code" v-model="item.stars_cha_code" placeholder="CHA"  v-validate="'required'" :state="validateState('stars_cha_code')"></b-form-input>
                <b-form-invalid-feedback>
                  {{ errors.first('stars_cha_code') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-form-row>

          <b-form-row>
            <b-col md="3">
              <b-form-group label="ShipTo">
                <b-form-input type="text"  name="ship_to" v-model="item.ship_to" placeholder="ShipTo"  v-validate="'required'" :state="validateState('ship_to')"></b-form-input>
                <b-form-invalid-feedback>
                  {{ errors.first('ship_to') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group label="NIV UFS">
                <b-form-input type="number" step="0.01" min="0" name="ufs_niv" v-model="item.ufs_niv" placeholder="NIV UFS"  v-validate="'required'" :state="validateState('ufs_niv')"></b-form-input>
                <b-form-invalid-feedback>
                  {{ errors.first('ufs_niv') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group label="NIV Spreads">
                <b-form-input type="number" step="0.01" min="0" name="spreads_niv" v-model="item.spreads_niv" placeholder="NIV Spreads"  v-validate="'required'" :state="validateState('spreads_niv')"></b-form-input>
                <b-form-invalid-feedback>
                  {{ errors.first('spreads_niv') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group label="UFS TO Top10">
                <b-form-input type="number" step="0.01" min="0" name="ufs_to_top10" v-model="item.ufs_to_top10" placeholder="UFS TO Top10"  v-validate="'required'" :state="validateState('ufs_to_top10')"></b-form-input>
                <b-form-invalid-feedback>
                  {{ errors.first('ufs_to_top10') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group label="UFS TO Total">
                <b-form-input type="number" step="0.01" min="0" name="ufs_to_total" v-model="item.ufs_to_total" placeholder="UFS TO Total"  v-validate="'required'" :state="validateState('ufs_to_total')"></b-form-input>
                <b-form-invalid-feedback>
                  {{ errors.first('ufs_to_total') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group label="Spreads TO Top10">
                <b-form-input type="number" step="0.01" min="0" name="spreads_to_top10" v-model="item.spreads_to_top10" placeholder="Spreads TO Top10"  v-validate="'required'" :state="validateState('spreads_to_top10')"></b-form-input>
                <b-form-invalid-feedback>
                  {{ errors.first('spreads_to_top10') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group label="Spreads TO Total">
                <b-form-input type="number" step="0.01" min="0" name="spreads_to_total" v-model="item.spreads_to_total" placeholder="Spreads TO Total"  v-validate="'required'" :state="validateState('spreads_to_total')"></b-form-input>
                <b-form-invalid-feedback>
                  {{ errors.first('spreads_to_total') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-form-row>



          <div slot="footer">
            <div class="row">
              <div class="col-sm-3">
                <router-link :to="{name:'shipto_objectives.index'}" size="sm" variant="danger"><i class="fa fa-ban"></i> Cancelar</router-link>

              </div>
              <div class="col-sm-9 text-right">
                <b-button type="submit" size="sm" variant="primary"><i class="fa fa-save"></i> Gravar</b-button>
                <b-button type="button" v-on:click="validateBeforeSubmit($event,true)" size="sm" variant="primary"><i class="fa fa-save"></i> Gravar e fechar</b-button>
              </div>
            </div>
          </div>
        </b-card>


      </b-col>
      <b-col md="6">
        <b-card>
          <div slot="header">
            <strong>Debug </strong>
          </div>
          <pre>{{ item }}</pre>

        </b-card>
      </b-col>
      <!--/.col-->

    </div>
  </form>

</div>
</template>

<script>
import lists from '@/components/States.js'
export default {
  name: 'BestofObjectiveEdit',
  props: ['id'],
  components: {  },
  data() {
    return {
      lists: lists,
      dataLoaded: false,
      item: {
        ym: '',
        stars_st_code: 0,
        stars_cha_code: 0,
        obj_top10: 0,
        obj_usg_ufs: 0,
        obj_usg_spreads: 0
      }
    }
  },
  methods: {
    validateBeforeSubmit(evt, close) {
      evt.preventDefault()
      console.log('check validation')
      this.$validator.validateAll().then((result) => {
        console.log('validation results:', result)
        if (result) {
          console.log('all fields ok. submit')
          this.submit(evt, close)
          return
        }
        this.$bvToast.toast(`Tem campos inválidos`, { autoHideDelay: 5000, variant: 'danger', solid: true })
      })
    },
    validateState(ref) {
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
        return !this.errors.has(ref)
      }
      return null
    },
    submit(e, close) {
      e.preventDefault()
      var data = {
        data: this.item
      }
      if (this.item.id) {
        this.axios.put('stars/shipto_objectives' + '/' + this.item.id, data)
          .then(response => {
            this.item = response.data.data
            this.$bvToast.toast(`item gravado com sucesso`, { autoHideDelay: 5000, variant: 'success', solid: true })
            if (close) {
              this.$router.push({
                name: 'shipto_objectives.index'
              })
            }
          })
          .catch(response => {
            this.$bvToast.toast(response.message, { autoHideDelay: 5000, variant: 'danger', solid: true })
          })
      } else {
        this.axios.post('stars/shipto_objectives', data)
          .then(response => {
            this.item = response.data.data
            this.$bvToast.toast(`item gravado com sucesso`, { autoHideDelay: 5000, variant: 'success', solid: true })
            this.$router.push({
              name: 'shipto_objectives.edit',
              params: {
                id: this.item.id
              }
            })
          })
          .catch(error => {
            this.$bvToast.toast(error.response.data.message, { autoHideDelay: 5000, variant: 'danger', solid: true })
          })
      }
    }
  },
  created() {
    var id = this.$route.params.id
    if (typeof id !== 'undefined') {
      this.axios.get('stars/shipto_objectives' + '/' + id)
        .then(response => {
          this.item = response.data.data
          this.dataLoaded = true
          if(!this.item.dealer) {
            this.item.dealer = {
              data: {}
            }
          }
          if(!this.item.zone) {
            this.item.zone = {
              data: {}
            }
          }
        })
        .catch(response => {
          this.$bvToast.toast(response.message, { autoHideDelay: 5000, variant: 'danger', solid: true })
          this.$router.push({
            name: 'shipto_objectives.index'
          })
        })
    } else {
      this.dataLoaded = true
    }
  }
}
</script>
